export default "__VITE_ASSET__CllnDP5d__"